import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isActiveScheduleLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_SCHEDULE_LIST_SUCCESS:
    case actionTypes.FETCH_SCHEDULE_LIST_ERROR:
      return action.payload;
    case actionTypes.CLEAR_SCHEDULE_INFO:
      return action.payload;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.FETCH_SCHEDULE_LIST:
          return Object.assign({}, state, { isActiveScheduleLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.FETCH_SCHEDULE_LIST:
          return Object.assign({}, state, { isActiveScheduleLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
